// InfoProfile.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Badge,
  Input
} from "reactstrap";
import { withTranslation } from "react-i18next";

import { Link, useParams, useLocation } from 'react-router-dom';

import { Check, X, Star, Dot, UserPen, Plus } from 'lucide-react';

import './InfoProfile.css';
import VipBadge from "../../components/VipBadge";
import CardCarousel from './components/InfoProfileTopicCardCarousel';

import { uploadImage, fetchImage } from "utils/images/imageManager";

import home4 from 'assets/images/info/home4.png';
import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import { useSelector, useDispatch } from "react-redux";

import axiosInstance from "utils/axiosInstance";

import PostsSection from "./PostsSection";
import TopicSection from "./TopicSection";
import FollowerSection from "./FollowerSection";
import BookshelfSection from "./BookshelfSection";
import SettingsSection from "./SettingsSection";


const InfoProfile = ({ t }) => {

  const dispatch = useDispatch();

  //--------------------------------------------------
  // States
  //--------------------------------------------------

  //const [myInfoProfile, setMyInfoProfile] = useState({});
  //const [myInfoTopics, setMyInfoTopics] = useState([]);
  //const [myInfoPosts, setMyInfoPosts] = useState([]);

  //const [profileBackgroundUrl, setProfileBackgroundUrl] = useState("");
  const [isBackgroundUrlLoaded, setIsBackgroundUrlLoaded] = useState(false);
  //const [profileImageUrl, setProfileImageUrl] = useState("");
  const [isProfileUrlLoaded, setIsProfileUrlLoaded] = useState(false);

  //const [imageMap, setImageMap] = useState(new Map());

  //const [profileLoading, setProfileLoading] = useState(true);
  //const [dataFetchError, setDataFetchError] = useState(null);

  // Editing Name and Bio
  const [editingDisplayName, setEditingDisplayName] = useState(false);
  const [editingBio, setEditingBio] = useState(false);
  const [displayNameDraft, setDisplayNameDraft] = useState('');
  const [bioDraft, setBioDraft] = useState('');
  const bioInputRef = useRef(null);

  const handleBioChange = (e) => {
    setBioDraft(e.target.value);

    if (bioInputRef.current) {
      bioInputRef.current.style.height = "auto"; // Reset height
      bioInputRef.current.style.height = bioInputRef.current.scrollHeight + "px"; // Resize
    }
  };
  useEffect(() => {
    if (editingBio && bioInputRef.current) {
      bioInputRef.current.style.height = "auto";
      bioInputRef.current.style.height = bioInputRef.current.scrollHeight + "px";
    }
  }, [editingBio]);



  const { 
    profile: myInfoProfile, 
    topics: myInfoTopics, 
    posts: myInfoPosts, 
    loading: profileLoading, 
    error: dataFetchError
  } = useSelector(state => state.infoProfile);

  const imageMap = useSelector(state => state.imageMap);
  const profileBackgroundUrl = myInfoProfile?.backgroundImage;
  const profileImageUrl = myInfoProfile?.profileImage;

  useEffect(() => {
    dispatch({ type: "INFO_PROFILE_FETCH_REQUEST" });
  }, []);


  useEffect(()=>{
    console.log('myInfoProfile:', myInfoProfile);
  },[myInfoProfile])

  //--------------------------------------------------
  // Load infoProfile and userTopics on mount
  //--------------------------------------------------

  /*
  const fetchData = async () => {
    try {
      setProfileLoading(true);
      setDataFetchError(null);

      // Load User Info Profile
      const [profileResponse, topicResponse, postsResponse] = await Promise.all([
        axiosInstance.get(`/knovia/myInfo/userInfoProfile`),
        axiosInstance.get(`/knovia/myInfo/userInfoTopics`),
        axiosInstance.get(`/knovia/myInfo/userInfoPosts`),
      ]);

      console.log('Profile Loaded:', profileResponse.data);
      setMyInfoProfile(profileResponse.data);

      console.log('User Topics Loaded:', topicResponse.data);
      setMyInfoTopics(topicResponse.data);

      console.log('User Posts Loaded:', postsResponse.data);
      setMyInfoPosts(postsResponse.data);

      return {
        profile: profileResponse.data,
        topics: topicResponse.data,
        posts: postsResponse.data
      };
    } catch (err) {
      console.error(err);
      setDataFetchError("Failed to load data.");
      return null; // <- This ensures the caller knows the fetch failed
    } finally {
      setProfileLoading(false);
    }
  };

  const fetchProfileImages = async (profile) => {
    try {
      const backgroundPromise = profile?.backgroundImage
        ? fetchImage(profile.backgroundImage, "original")
        : Promise.resolve(null);

      if (!profile?.backgroundImage) { setIsBackgroundUrlLoaded(true); }

      const profilePromise = profile?.profileImage
        ? fetchImage(profile.profileImage, "original")
        : Promise.resolve(null);

      if (!profile?.profileImage) { setIsProfileUrlLoaded(true); }

      const [backgroundUrl, profileImgUrl] = await Promise.all([
        backgroundPromise,
        profilePromise,
      ]);

      setIsBackgroundUrlLoaded(true);
      setIsProfileUrlLoaded(true);

      if (backgroundUrl) setProfileBackgroundUrl(backgroundUrl);
      if (profileImgUrl)  setProfileImageUrl(profileImgUrl);
    } catch (err) {
      console.error("Error fetching profile images:", err);
    }
  };

  const fetchTopicAndPostsImages = async (topics, posts) => {
    const newMap = new Map(imageMap); // preserve existing

    const allFilenames = new Set();

    // Add topic images
    topics.forEach((topic) => {
      if (topic.image && !newMap.has(topic.image)) {
        allFilenames.add(topic.image);
      }
    });

    // Add post images (array)
    posts.forEach((post) => {
      if (post.profileImage && !newMap.has(post.profileImage)) {
        allFilenames.add(post.profileImage);
      }
      if (Array.isArray(post.images)) {
        post.images.forEach((img) => {
          if (img && !newMap.has(img)) {
            allFilenames.add(img);
          }
        });
      }
    });

    await Promise.all(
      [...allFilenames].map(async (filename) => {
        try {
          const url = await fetchImage(filename, "original");
          newMap.set(filename, url);
        } catch (e) {
          console.error("Failed to load image:", filename);
        }
      })
    );

    setImageMap(newMap);
  };

  const loadInfoProfileData = async () => {
    const dataFetched = await fetchData();
    if (!dataFetched) return;

    const { profile, topics, posts } = dataFetched;

    if(profile) {
      fetchProfileImages(profile);
    }
    if(topics || posts) {
      fetchTopicAndPostsImages(topics, posts);
    }
  }

  useEffect(() => {
    loadInfoProfileData();
  }, []);
  */

  //--------------------------------------------------
  // Editing Images
  //--------------------------------------------------
  /*
  const handleUploadImageFileChange = async (e, type) => {
    const file = e.target.files?.[0];
    if (!file || !type) return;

    const tempUrl = URL.createObjectURL(file);
    if (type === 'backgroundImage') {
      setProfileBackgroundUrl(tempUrl);
    } else if (type === 'profileImage') {
      setProfileImageUrl(tempUrl);
    }

    try {
      const filename = await uploadImage(file);
      const imgUrl = await fetchImage(filename, "original");

      // Update state with final image URL
      if (type === 'backgroundImage') {
        setProfileBackgroundUrl(imgUrl);
      } else if (type === 'profileImage') {
        setProfileImageUrl(imgUrl);
      }

      // Patch to backend
      await axiosInstance.patch('/knovia/myInfo/userInfoProfile/updateImage', {
        [type]: filename,
      });

      // Optionally refetch or update state
      setMyInfoProfile((prev) => ({
        ...prev,
        [type]: filename,
      }));
    } catch (err) {
      console.error(`Failed to upload ${type}:`, err);
    }
  };
  */
  const handleUploadImageFileChange = async (e, type) => {
    const file = e.target.files?.[0];
    if (!file || !type) return;

    const tempUrl = URL.createObjectURL(file);

    // Optionally: Dispatch a temporary update for preview (local only if needed)

    try {
      const filename = await uploadImage(file);
      const imgUrl = await fetchImage(filename, "original");

      // Patch to backend
      await axiosInstance.patch('/knovia/myInfo/userInfoProfile/updateImage', {
        [type]: filename,
      });

      // Dispatch Redux update
      dispatch({
        type: 'INFO_PROFILE_UPDATE_IMAGE',
        payload: { [type]: filename },
      });

      // Optionally fetch image again
      dispatch({
        type: 'FETCH_MISSING_IMAGES',
        payload: { filenames: [filename] },
      });

    } catch (err) {
      console.error(`Failed to upload ${type}:`, err);
    }
  };

  //--------------------------------------------------
  // Editing Names and Bios
  //--------------------------------------------------

  const handleEditDisplayName = () => {
    setDisplayNameDraft(myInfoProfile?.displayName || '');
    setEditingDisplayName(true);
  };
  /*
  const handleSaveDisplayName = async () => {
    try {
      await axiosInstance.patch('/knovia/myInfo/userInfoProfile/updateText', {
        displayName: displayNameDraft,
      });

      setMyInfoProfile(prev => ({
        ...prev,
        displayName: displayNameDraft,
      }));

      setEditingDisplayName(false);
    } catch (err) {
      console.error("Failed to update display name:", err);
    }
  };
  */
  const handleSaveDisplayName = async () => {
    try {
      await axiosInstance.patch('/knovia/myInfo/userInfoProfile/updateText', {
        displayName: displayNameDraft,
      });

      dispatch({
        type: 'INFO_PROFILE_UPDATE_TEXT',
        payload: { displayName: displayNameDraft },
      });

      setEditingDisplayName(false);
    } catch (err) {
      console.error("Failed to update display name:", err);
    }
  };

  const handleEditBio = () => {
    setBioDraft(myInfoProfile?.bio || '');
    setEditingBio(true);
  };
  /*
  const handleSaveBio = async () => {
    try {
      await axiosInstance.patch('/knovia/myInfo/userInfoProfile/updateText', {
        bio: bioDraft,
      });

      setMyInfoProfile(prev => ({
        ...prev,
        bio: bioDraft,
      }));

      setEditingBio(false);
    } catch (err) {
      console.error("Failed to update bio:", err);
    }
  };
  */
  const handleSaveBio = async () => {
    try {
      await axiosInstance.patch('/knovia/myInfo/userInfoProfile/updateText', {
        bio: bioDraft,
      });

      dispatch({
        type: 'INFO_PROFILE_UPDATE_TEXT',
        payload: { bio: bioDraft },
      });

      setEditingBio(false);
    } catch (err) {
      console.error("Failed to update bio:", err);
    }
  };


  //--------------------------------------------------
  // Adding User Topic
  //--------------------------------------------------
  /*
  const handleAddNewTopic = async () => {
    try {
      const res = await axiosInstance.post('/knovia/myInfo/userInfoTopic');
      const newTopic = res.data;

      setMyInfoTopics(prev => [...prev, newTopic]);
    } catch (err) {
      console.error("Failed to create new topic:", err);
      alert("新增主題失敗，請稍後再試");
    }
  };
  */

  const handleAddNewTopic = async () => {
    try {
      const res = await axiosInstance.post('/knovia/myInfo/userInfoTopic');
      const newTopic = res.data;

      dispatch({
        type: 'INFO_PROFILE_ADD_TOPIC',
        payload: newTopic,
      });
    } catch (err) {
      console.error("Failed to create new topic:", err);
      alert("新增主題失敗，請稍後再試");
    }
  };


  const [activeTab, setActiveTab] = useState('topics');

  //--------------------------------------------------
  // Return
  //--------------------------------------------------

  return (

    <div className="page-content info-profile" 
      style={{ "--page-content-background": `url(${home4})` }}
    >

      <Container fluid className="info-profile-container">

        {/* Desktop header background */}
        <div className="d-none d-md-block">
          <div
            className="info-profile-top-image"
            style={{
              backgroundImage: `url(${imageMap[profileBackgroundUrl] || placeholder_image})`,
              height: '240px',
              cursor: 'pointer',
            }}
            onClick={() => document.getElementById('backgroundUploadDesktop').click()}
          />

          <input
            type="file"
            accept="image/*"
            id="backgroundUploadDesktop"
            style={{ display: 'none' }}
            onChange={(e) => handleUploadImageFileChange(e, 'backgroundImage')}
          />
        </div>

        <div className="d-block d-md-none">
          {/* Profile Image at top */}
          <div 
            /*className={`info-profile-top-image ${isBackgroundUrlLoaded ? 'fade-in' : ''}`}*/
            className={`info-profile-top-image`}
            style={{
              backgroundImage: `url(${imageMap[profileBackgroundUrl] || placeholder_image})`,
              cursor: 'pointer',
            }}
            onClick={() => document.getElementById('backgroundUpload').click()}
          >
          </div>

          <input
            type="file"
            accept="image/*"
            id="backgroundUpload"
            style={{ display: 'none' }}
            onChange={(e) => handleUploadImageFileChange(e, 'backgroundImage')}
          />
        </div>

        <Card className="info-profile-card">
          <CardBody className="info-profile-card-body">

              {/*------ Big Screen ------*/}
              <div className="d-none d-md-block">
                {/* Profile row under header */}
                <Row className="align-items-end" style={{ padding: '20px 30px' }}>
                  <Col md="2" className="d-flex justify-content-center">
                    <input
                      type="file"
                      accept="image/*"
                      id="profileUploadDesktop"
                      style={{ display: 'none' }}
                      onChange={(e) => handleUploadImageFileChange(e, 'profileImage')}
                    />
                    <div
                      style={{
                        width: '120px',
                        height: '120px',
                        borderRadius: '50%',
                        backgroundImage: `url(${imageMap[profileImageUrl] || placeholder_image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        border: '3px solid #fff',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                        cursor: 'pointer',
                      }}
                      onClick={() => document.getElementById('profileUploadDesktop').click()}
                    />
                  </Col>
                  <Col md="10">
                    {/* Name and Bio */}
                    <div className="d-flex align-items-center" style={{ marginBottom: '8px' }}>
                      {editingDisplayName ? (
                        <div className="mb-2 d-flex align-items-center">
                          <Input
                            type="text"
                            maxLength={30}
                            value={displayNameDraft}
                            onChange={(e) => setDisplayNameDraft(e.target.value)}
                            style={{ maxWidth: '320px', fontSize: '20px' }}
                          />
                          <Button size="sm" color="success" className="ms-2" style={{ padding: '5px 5px' }} onClick={handleSaveDisplayName}>
                            <Check size={16} />
                          </Button>
                          <Button size="sm" color="secondary" className="ms-1" style={{ padding: '5px 5px' }} onClick={() => setEditingDisplayName(false)}>
                            <X size={16} />
                          </Button>
                        </div>
                      ) : (
                        <>
                          <h3 className="mb-0" style={{ fontWeight: 600 }}>{myInfoProfile?.displayName}</h3>
                          <UserPen
                            size={18}
                            style={{ marginLeft: 10, cursor: 'pointer' }}
                            onClick={() => { setEditingBio(false); handleEditDisplayName(); }}
                          />
                        </>
                      )}
                    </div>

                    <div className="d-flex align-items-start" style={{ marginBottom: '10px' }}>
                      {editingBio ? (
                        <>
                          <Input
                            type="textarea"
                            maxLength={100}
                            value={bioDraft}
                            onChange={handleBioChange}
                            innerRef={bioInputRef}
                            rows={1}
                            style={{ maxWidth: '600px', resize: 'none', overflow: 'hidden' }}
                          />
                          <Button size="sm" color="success" className="ms-2" style={{ padding: '5px 5px' }} onClick={handleSaveBio}>
                            <Check size={16} />
                          </Button>
                          <Button size="sm" color="secondary" className="ms-1" style={{ padding: '5px 5px' }} onClick={() => setEditingBio(false)}>
                            <X size={16} />
                          </Button>
                        </>
                      ) : (
                        <>
                          <p className="mb-0" style={{ fontSize: '14px', color: '#666', maxWidth: '700px' }}>{myInfoProfile?.bio}</p>
                          <UserPen
                            size={18}
                            style={{ marginLeft: 10, cursor: 'pointer' }}
                            onClick={() => { setEditingDisplayName(false); handleEditBio(); }}
                          />
                        </>
                      )}
                    </div>

                    <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                      <VipBadge vipLevel="VIP1" imageSize={36} textSize={40} />
                      <Button color="soft-success" style={{ height: '32px', paddingTop: '4px' }}>
                        1000+ 人已追蹤
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>


            {/*------ Small Screen ------*/}
            <div className="d-block d-md-none">

              {/* Topic Thumbnail */}
              <input
                type="file"
                accept="image/*"
                id="profileUpload"
                style={{ display: 'none' }}
                onChange={(e) => handleUploadImageFileChange(e, 'profileImage')}
              />

              <div 
                className={`info-profile-thumbnail ${isProfileUrlLoaded ? 'fade-in' : ''}`}
                style={{
                  backgroundImage: `url(${imageMap[profileImageUrl] || placeholder_image})`,
                  cursor: 'pointer',
                }}
                onClick={() => document.getElementById('profileUpload').click()}
              >
              </div>

              {/* Name and Bio */}
              <Row>
                <Col className="info-profile-label">
                  {/* Display Name + Pen */}
                  <div className="d-flex align-items-center"
                    style={{
                      maxWidth: "50%",
                      wordBreak: "break-word",
                      textAlign: "center"
                    }}
                  >
                    {editingDisplayName ? (
                      <div className="mb-2 d-flex align-items-center">
                        <Input
                          type="text"
                          maxLength={30}
                          value={displayNameDraft}
                          onChange={(e) => setDisplayNameDraft(e.target.value)}
                          style={{ maxWidth: "300px", fontSize: "18px" }}
                        />
                        <Button size="sm" color="success" className="ms-2" style={{ padding: "5px 5px" }} onClick={handleSaveDisplayName}>
                          <Check size={16} />
                        </Button>
                        <Button size="sm" color="secondary" className="ms-1" style={{ padding: "5px 5px" }} onClick={() => setEditingDisplayName(false)}>
                          <X size={16} />
                        </Button>
                      </div>
                    ) : (
                      <>
                        <p className="mb-1 d-inline-block">{myInfoProfile?.displayName}</p>
                        <UserPen
                          size={16}
                          style={{ marginLeft: 8, cursor: 'pointer', flexShrink: "0" }}
                          onClick={()=>{setEditingBio(false); handleEditDisplayName();}}
                        />
                      </>
                    )}
                  </div>

                  {/* Bio + Pen */}
                  <div className="d-flex align-items-center"
                    style={{
                      maxWidth: "70%",
                      wordBreak: "break-word",
                      textAlign: "center"
                    }}
                  >
                    {editingBio ? (
                      <>
                        <Input
                          type="textarea"
                          maxLength={100}
                          value={bioDraft}
                          onChange={handleBioChange}
                          innerRef={bioInputRef}
                          rows={1}
                          style={{ maxWidth: "400px", resize: "none", overflow: "hidden" }}
                        />
                        <Button size="sm" color="success" className="ms-2" style={{ padding: "5px 5px" }} onClick={handleSaveBio}>
                          <Check size={16} />
                        </Button>
                        <Button size="sm" color="secondary" className="ms-1" style={{ padding: "5px 5px" }} onClick={() => setEditingBio(false)}>
                          <X size={16} />
                        </Button>
                      </>
                    ) : (
                      <>
                        <p
                          className="mb-0"
                          style={{ fontSize: "13.5px", color: "#848282" }}
                        >
                          {myInfoProfile?.bio}
                        </p>
                        <UserPen
                          size={16}
                          style={{ marginLeft: 8, cursor: 'pointer', flexShrink: "0" }}
                          onClick={()=>{setEditingDisplayName(false); handleEditBio();}}
                        />
                      </>
                    )}
                  </div>

                </Col>
              </Row>

              {/* Star and VIP level */}
              <Row>
                <Col className="info-profile-star-col">
                  <div style={{ marginTop: "-6px" }}>
                    <VipBadge vipLevel="VIP1" imageSize={35} textSize={42} />
                  </div>
                </Col>
              </Row>

              <Row style={{ marginBottom: "30px" }}>
                <Col className="info-profile-filled-count-col">
                  <Button color="soft-success" style={{
                    height: "30px",
                    paddingTop: "3.5px"
                  }}>
                    1000+ 人已追蹤
                  </Button>
                </Col>
              </Row>

            </div>

            <div className="center-tab-bar d-flex justify-content-around mb-3">
              <button
                className={`tab-button ${activeTab === 'namecard' ? 'active' : ''}`}
                onClick={() => setActiveTab('namecard')}
              >
                名片
              </button>
              <button
                className={`tab-button ${activeTab === 'topics' ? 'active' : ''}`}
                onClick={() => setActiveTab('topics')}
              >
                主題
              </button>
              <button
                className={`tab-button ${activeTab === 'posts' ? 'active' : ''}`}
                onClick={() => setActiveTab('posts')}
              >
                我的貼文
              </button>
              <button
                className={`tab-button ${activeTab === 'followers' ? 'active' : ''}`}
                onClick={() => setActiveTab('followers')}
              >
                追蹤者
              </button>
              <button
                className={`tab-button ${activeTab === 'bookshelf' ? 'active' : ''}`}
                onClick={() => setActiveTab('bookshelf')}
              >
                書架
              </button>
              <button
                className={`tab-button ${activeTab === 'settings' ? 'active' : ''}`}
                onClick={() => setActiveTab('settings')}
              >
                設定
              </button>
            </div>

            <div className="tab-content-area">
              {/*
              {activeTab === 'posts' && <PostsSection />}
              {activeTab === 'replies' && <RepliesSection />}
              {activeTab === 'media' && <MediaSection />}
              {activeTab === 'reposts' && <RepostsSection />}
              {activeTab === 'notifications' && <NotificationsSection />}
              */}
              {activeTab === 'namecard' && (
                <p>Namecard Section </p>
              )}
              {activeTab === 'topics' && (
                <TopicSection 
                  myInfoTopics={myInfoTopics}
                  imageMap={imageMap}
                  handleAddNewTopic={handleAddNewTopic}
                />
              )}
              {activeTab === 'posts' && (
                <PostsSection
                  myInfoPosts={myInfoPosts}
                  imageMap={imageMap}
                />
              )}
              {activeTab === 'followers' && (
                <FollowerSection 
                  myInfoProfile={myInfoProfile}
                />
              )}
              {activeTab === 'bookshelf' && (
                <BookshelfSection />
              )}
              {activeTab === 'settings' && (
                <SettingsSection 
                  myInfoProfile={myInfoProfile}
                />
              )}
            </div>

          </CardBody>
        </Card>

      </Container>
    </div>
  );
};

export default withTranslation()(InfoProfile);


